export default "__VITE_ASSET__BOYfxYPp__"